export default {
  imgMap: {
    "pic": "https://pic.imgdb.cn/item/671e5d5cd29ded1a8c5d7b48.png",
    "icon_small": "https://pic.imgdb.cn/item/66a9f910d9c307b7e9121112.png",
    "logo": "https://pic.imgdb.cn/item/66a9f910d9c307b7e9121100.png",
    "img1": "https://pic.imgdb.cn/item/66a9f910d9c307b7e91210f6.png",
    "service4": "https://pic.imgdb.cn/item/66a9f1e8d9c307b7e90b61e4.jpg",
    "service3": "https://pic.imgdb.cn/item/66a9f1e7d9c307b7e90b61bf.jpg",
    "service2": "https://pic.imgdb.cn/item/66a9f1e7d9c307b7e90b619f.jpg",
    "contact_us_bg": "https://pic.imgdb.cn/item/66a9f1e2d9c307b7e90b5d51.jpg",
    "banner_2": "https://pic.imgdb.cn/item/66a9f1e2d9c307b7e90b5d2e.jpg",
    "banner_1": "https://pic.imgdb.cn/item/66a9f1e2d9c307b7e90b5d0d.jpg",
    "about_img": "https://pic.imgdb.cn/item/66a9f1e1d9c307b7e90b5cd5.png",
    "service1": "https://pic.imgdb.cn/item/66a9f1e1d9c307b7e90b5cc9.jpg",
    "banner4": "https://pic.imgdb.cn/item/66a9f1bfd9c307b7e90b3f9c.jpg",
    "banner3": "https://pic.imgdb.cn/item/66a9f1bfd9c307b7e90b3f4f.jpg",
    "banner2": "https://pic.imgdb.cn/item/66a9f1bfd9c307b7e90b3f1f.jpg",
    "banner1": "https://pic.imgdb.cn/item/66a9f1bfd9c307b7e90b3eed.jpg",
    "banner5": "https://pic.imgdb.cn/item/66a9f1bed9c307b7e90b3eb8.jpg",
    "banner6": "https://pic.imgdb.cn/item/671e85f1d29ded1a8c7d1081.jpg",
  },
}



// WEBPACK FOOTER //
// ./src/api/api.js